import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { User } from '../types';

interface UsersLocation {
  latitude: number;
  longitude: number;
}

export interface UserState {
  user: User | null;
  usersLocation: UsersLocation;
  userLoading: boolean;
  loginLoading: boolean;
}

const initialState: UserState = {
  user: null,
  usersLocation: {
    latitude: 37.0902,
    longitude: -95.7129,
  },
  userLoading: true,
  loginLoading: false,
};

const user = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
    setUsersLocation: (state, action: PayloadAction<UsersLocation>) => {
      const option = action.payload;

      state.usersLocation = {
        latitude: option.latitude,
        longitude: option.longitude,
      };
    },
    setUserLoading: (state, action: PayloadAction<boolean>) => {
      state.userLoading = action.payload;
    },
    setLoginLoading: (state, action: PayloadAction<boolean>) => {
      state.loginLoading = action.payload;
    },
  },
});

export const { setUser, setUsersLocation, setUserLoading, setLoginLoading } =
  user.actions;

export default user.reducer;
